module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Live Odds")]), _vm._v(" "), (_vm.odds.mlb && _vm.odds.mlb.live && _vm.odds.mlb.live.data && _vm.odds.mlb.live.data.games.length) ? _c('table', [_c('thead', [_c('tr', {
    staticClass: "bg-green"
  }, [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                In Progress\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                Score\n              ")]), _vm._v(" "), _vm._l((_vm.odds.mlb.live.data.headers), function(h) {
    return _c('th', {
      key: h,
      staticClass: "text-right"
    }, [(h === 'BetAnySports') ? _c('a', {
      attrs: {
        "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=220&AffUrlID=1606&LandingPageID=1",
        "target": "_blank"
      }
    }, [_vm._v("BetAnySports")]) : _vm._e(), _vm._v(" "), (h === 'BetOnline') ? _c('a', {
      attrs: {
        "href": "https://record.commissionkings.ag/_k86Ic18Yvp3lE-K0mpYMyWNd7ZgqdRLk/1/",
        "target": "_blank"
      }
    }, [_vm._v("BetOnline")]) : _vm._e(), _vm._v(" "), (h !== 'BetAnySports' && h !== 'BetOnline') ? _c('span', [_vm._v("\n                  " + _vm._s(h) + "\n                ")]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "no-border"
  }, [_vm._l((_vm.odds.mlb.live.data.games), function(o) {
    return [_c('tr', {
      key: o.awayCode,
      staticStyle: {
        "z-index": "1"
      }
    }, [_c('td', {
      staticClass: "text-left no-border right-border bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.awayTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center no-border right-border"
    }, [_vm._v("\n                  " + _vm._s(o.awayScore) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right no-border right-border"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_away) + "\n                    " + _vm._s(odd.point_spread_away_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_away) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + "\n                  ")]) : _vm._e()])
    })], 2), _vm._v(" "), _c('tr', {
      key: o.homeCode,
      staticStyle: {
        "border-bottom": "1px"
      }
    }, [_c('td', {
      staticClass: "text-left bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.homeTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                  " + _vm._s(o.homeScore) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_home) + "\n                    " + _vm._s(odd.point_spread_home_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_home) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + " " + _vm._s(odd.under_line) + "\n                  ")]) : _vm._e()])
    })], 2)]
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.upcomingGames.length) ? _c('div', {
    staticClass: "column"
  }, [_c('table', [_c('thead', [_c('tr', {
    staticClass: "bg-green"
  }, [_c('th', {
    staticClass: "text-left",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                Upcoming\n              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n                Date\n              ")]), _vm._v(" "), _vm._l((_vm.upcomingHeaders), function(h) {
    return _c('th', {
      key: h,
      staticStyle: {
        "text-align": "right"
      }
    }, [(h === 'BetOnline') ? _c('a', {
      attrs: {
        "href": "https://record.commissionkings.ag/_k86Ic18Yvp3lE-K0mpYMyWNd7ZgqdRLk/1/",
        "target": "_blank"
      }
    }, [_vm._v("BetOnline")]) : _vm._e(), _vm._v(" "), (h === 'BetAnySports') ? _c('a', {
      attrs: {
        "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=220&AffUrlID=1606&LandingPageID=1",
        "target": "_blank"
      }
    }, [_vm._v("BetAnySports")]) : _vm._e(), _vm._v(" "), (h !== 'BetAnySports' && h !== 'BetOnline') ? _c('span', [_vm._v("\n                  " + _vm._s(h) + "\n                ")]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "no-border"
  }, [_vm._l((_vm.upcomingGames), function(o) {
    return [_c('tr', {
      key: o.awayCode
    }, [_c('td', {
      staticClass: "text-left no-border right-border bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.awayTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center no-border right-border"
    }, [_vm._v("\n                  " + _vm._s(o.date) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right no-border right-border"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_away) + "\n                    " + _vm._s(odd.point_spread_away_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_away) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + " " + _vm._s(odd.over_line) + "\n                  ")]) : _vm._e()])
    })], 2), _vm._v(" "), _c('tr', {
      key: o.homeCode,
      staticStyle: {
        "border-bottom": "1px"
      }
    }, [_c('td', {
      staticClass: "text-left bg-grey-10"
    }, [_vm._v("\n                  " + _vm._s(o.homeTeam) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                  " + _vm._s(o.time) + "\n                ")]), _vm._v(" "), _vm._l((o.odds['Game']), function(odd, index) {
      return _c('td', {
        key: index,
        staticClass: "text-right"
      }, [(_vm.oddType.value === 'spread') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.point_spread_home) + "\n                    " + _vm._s(odd.point_spread_home_line) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'moneyline') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.money_line_home) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.oddType.value === 'total') ? _c('span', [_vm._v("\n                    " + _vm._s(odd.total_number) + " " + _vm._s(odd.under_line) + "\n                  ")]) : _vm._e()])
    })], 2)]
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100px",
      "padding-left": "2px"
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('h6', [_vm._v("Select Sport")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("MLB")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "target": "_top"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://affiliates.betanysports.eu/tracking/banner.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "hspace": "0",
      "vspace": "0",
      "border": "0",
      "alt": "Bet at Betanysports.eu"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa8910c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Odds.vue
// module id = 522
// module chunks = 1